import { Trans, useTranslation } from 'react-i18next';
import { Flex, TextComponent } from '@monorepo/react-components';
import { ContactSupportButton } from './contact-support-button';

export const NoMoreRetries = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation(['mailConfirmation']);

  return (
    <Flex align="center" vertical gap={15} className="mail-modal">
      <TextComponent
        level={2}
        weight={600}
        className="title"
        textAlign="center"
      >
        {t('mailConfirmation:protecting_your_account')}
      </TextComponent>
      <Flex vertical gap={12}>
        <TextComponent textAlign="center" weight={600}>
          {t('mailConfirmation:you_ve_used_all_your_attempts.')}
        </TextComponent>
        <TextComponent textAlign="center" weight={400}>
          <Trans
            ns="mailConfirmation"
            i18nKey="please_contact_our_support_team"
            components={{ br: <br /> }}
          />
        </TextComponent>
      </Flex>
      <ContactSupportButton
        flow="mail-confirmation"
        isLoading={isLoading}
        type="primary"
      />
    </Flex>
  );
};
